import { Model } from '@/models/Model';
import client from '@/support/Client';
export class Generate extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Generate';
        this.$endpoint = '/commands/fill-idp';
        this.$fillable = ['school'];
    }
    resetPeriods() {
        const url = '/commands/reset-periods';
        return client('post', url, {});
    }
    resetLevels() {
        const url = '/commands/reset-levels';
        return client('post', url, {});
    }
    syncParnassys(state) {
        const url = '/commands/sync-parnassys';
        return client('post', url, { state });
    }
    initParnassys() {
        const url = '/commands/init-parnassys';
        return client('post', url, {});
    }
    syncGoalsets() {
        const url = '/commands/idp-projects';
        return client('post', url, {});
    }
}
export var SyncState;
(function (SyncState) {
    SyncState["STUDENTS"] = "students";
    SyncState["GUARDIANS"] = "guardians";
    SyncState["TEACHERS"] = "teachers";
})(SyncState || (SyncState = {}));
